// Super-admin "log in as user" impersonation state.
//
// Stored in localStorage (not sessionStorage) so it is shared across tabs of the
// same origin — e.g. opening an order in a new tab keeps the admin acting as the
// selected client. Because localStorage persists until explicitly removed, callers
// MUST clear it on sign-in and sign-out (see App.js auth observer + Auth/SSO sign-in)
// so a stale client_id can never leak into a different user's session.
const IMPERSONATION_KEY = 'client_id';

export const getImpersonatedClientId = () => {
    try {
        return window?.localStorage?.getItem(IMPERSONATION_KEY) || null;
    } catch {
        return null;
    }
};

export const setImpersonatedClientId = (clientId) => {
    try {
        window?.localStorage?.setItem(IMPERSONATION_KEY, clientId);
    } catch {
        /* storage unavailable (e.g. private mode) — no-op */
    }
};

export const clearImpersonatedClientId = () => {
    try {
        window?.localStorage?.removeItem(IMPERSONATION_KEY);
    } catch {
        /* storage unavailable (e.g. private mode) — no-op */
    }
};
